<template>
  <transition name="bg-modal">
    <div
      v-if="visible"
      class="bg-modal-overlay"
      role="presentation"
      @click.self="close"
    >
      <div
        class="bg-alert-modal"
        role="alertdialog"
        aria-modal="true"
        :aria-labelledby="titleId"
        :aria-describedby="messageId"
        @keydown.esc.prevent="close"
      >
        <header class="bg-alert-modal__header">
          <h2 :id="titleId" class="bg-alert-modal__title">{{ title }}</h2>
          <button
            type="button"
            class="bg-alert-modal__close"
            :aria-label="$t('common.close')"
            @click="close"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </header>

        <p :id="messageId" class="bg-alert-modal__message">{{ message }}</p>

        <div class="bg-alert-modal__actions">
          <button
            v-if="showCancel"
            type="button"
            class="bg-alert-modal__btn bg-alert-modal__btn--ghost"
            @click="close"
          >
            {{ cancelLabel }}
          </button>
          <button
            type="button"
            class="bg-alert-modal__btn bg-alert-modal__btn--primary"
            @click="confirm"
          >
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BlackGoldAlertModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default () {
        return this.$t('common.alertTitle')
      }
    },
    message: {
      type: String,
      default: ''
    },
    confirmLabel: {
      type: String,
      default () {
        return this.$t('common.confirm')
      }
    },
    cancelLabel: {
      type: String,
      default () {
        return this.$t('common.close')
      }
    },
    showCancel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleId () {
      return 'bg-alert-modal-title-' + this._uid
    },
    messageId () {
      return 'bg-alert-modal-message-' + this._uid
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
